import { IMetricsDataModel } from '../../../../data-models/metrics.data-model';
import { KPI_COMPONENTS, Kpi, KpiCalculationParams, KpiConfig, KpiConfigMeta } from '../../../../types';
import { format } from './kpi-formatter';

export class RealizedCostConfig implements KpiConfig {
  private id = KPI_COMPONENTS.REALIZED_COST as const;
  private title = 'Realized Cost';
  private type = 'currency';
  private costField: keyof IMetricsDataModel;

  constructor(costField?: keyof IMetricsDataModel) {
    this.costField = costField ?? 'realizedCost';
  }

  getMeta(): KpiConfigMeta {
    return {
      id: this.id,
      title: this.title,
      type: this.type,
    };
  }

  calculate({ data }: KpiCalculationParams): Kpi {
    const value =
      data?.metrics.reduce((total, metric) => {
        const value = (metric[this.costField] as number) ?? 0;

        return total + Math.max(0, value);
      }, 0) ?? 0;

    return {
      ...this.getMeta(),
      value,
      formatted: format(value, this.type),
    };
  }
}
